<script setup>
import { useVModel } from '#/general/useVModel'
import { inject, computed } from 'vue'
import RaumpioniereLogo from '#/general/RaumpioniereLogo'
import DialogCloseBtn from '#/general/DialogCloseBtn'
import AppDialog from '#/general/AppDialog'

const props = defineProps({
  visible: { type: Boolean },
  btnLabel: { type: String },
  title: { type: String },
  persistent: { type: Boolean },
  filterColor: { type: String },
  fixed: { type: Boolean, default: true }
})
const { components, application, screen } = inject('Shared')
defineEmits(['update:visible', 'clicked'])
const visible = useVModel(props, 'visible')
const fullPopupCss = computed(() => {
  if (screen.gt.xs) {
    return `background: ${components.value.fullPopup.backgroundColor}; width: ${components.value.fullPopup.containerMaxWidth}; padding: ${components.value.fullPopup.containerPadding}; margin: ${components.value.fullPopup.containerMargin};`
  }
  return `background: ${components.value.fullPopup.backgroundColor}; padding: ${components.value.fullPopup.containerPaddingMobile}; margin: ${components.value.fullPopup.containerMarginMobile};`
})
const titleCss = computed(() => `color: ${components.value.fullPopup.title.color}; font-size: ${screen.gt.xs ? components.value.fullPopup.title.fontSize : components.value.fullPopup.title.fontSizeMobile}; font-weight: ${screen.gt.xs ? components.value.fullPopup.title.fontWeight : components.value.fullPopup.title.fontWeightMobile};`)
const buttonCss = computed(() => `min-height: ${components.value.fullPopup.submitBtn.height}; background: ${components.value.fullPopup.submitBtn.background}; color: ${components.value.fullPopup.submitBtn.color}; font-size: ${screen.gt.xs ? components.value.fullPopup.submitBtn.fontSize : components.value.fullPopup.submitBtn.fontSizeMobile}; font-weight: ${screen.gt.xs ? components.value.fullPopup.submitBtn.fontWeight : components.value.fullPopup.submitBtn.fontWeightMobile};`)
</script>

<template lang="pug">
app-dialog(v-model:show-modal='visible' transition="float" maximized position="center" full-screen :fixed="fixed" :persistent="persistent" :filter-color="filterColor")
  template(#modal-content)
    .fullPopupOuterContainer
      .fullPopupInnerContainer(:style="fullPopupCss")
        dialog-close-btn(v-model:visible="visible")
        .mainTitle(:style="titleCss + `; color: ${components.fullPopup.title.color}`") {{ title }}
        .bodyContent(v-if="$slots.default")
          slot
        .fullPopupContainer
          .fullPopupBtn(:style="buttonCss" @click="$emit('clicked'); visible = false") {{ btnLabel }}
        .bottomContent(v-if="$slots.bottom")
          slot(name="bottom")
        raumpioniere-logo(type="GREY" v-if="application === 'WIDGET'")
</template>

<style lang="sass">
.fullPopupOuterContainer
  @media screen and (min-width: 1024px)
    padding: 20px 0
  @media screen and (max-width: 1023px)
  @media screen and (max-width: 599px)
    max-width: calc(100% - 30px)
    display: flex
    align-items: center
  .fullPopupInnerContainer
    box-shadow: 0px 15px 30px rgba(166, 166, 166, 0.25)
    display: flex
    flex-direction: column
    position: relative
    @media screen and (min-width: 1024px)
      border-radius: 10px !important
      max-width: 100%
    @media screen and (max-width: 1023px)
      border-radius: 10px !important
    .fullPopupContainer
      width: 100%
      display: flex
      justify-content: center
      @media screen and (min-width: 600px)
        border-radius: 10px !important
        margin-top: 25px
      @media screen and (max-width: 599px)
        margin-bottom: 20px
      .fullPopupBtn
        cursor: pointer
        display: flex
        flex-direction: row
        justify-content: center
        align-items: center
        padding: 0px 24px
        min-height: 54px
        border-radius: 10px
        text-align: center
        @media screen and (min-width: 600px)
          min-width: 336px
        @media screen and (max-width: 599px)
          width: 80%
    .footerContainer
      width: 100%
      display: flex
      flex-direction: row
      justify-content: space-between
      position: relative
      margin-top: 15px
      @media screen and (max-width: 1023px)
        margin-top: 35px
    .bodyContent
      font-style: normal
      font-weight: 500
      font-size: 18px
      line-height: 130%
      color: #626C85
      margin: 20px 0
    .bottomContent
      @media screen and (min-width: 1024px)
        margin-top: 30px
      @media screen and (max-width: 1023px)
        margin-top: 15px
    .backBtnContainer
      display: flex
      justify-content: center
      align-items: center
      @media screen and (max-width: 1023px)
        width: 100%
    .mainTitle
      line-height: 25px
      @media screen and (min-width: 1024px)
        margin-bottom: 20px
      @media screen and (max-width: 1023px)
        margin-top: 15px
        margin-bottom: 15px
    .sendBtn
      min-width: 283px
      min-height: 54px
      background: #5FEFC0
      border-radius: 10px
      font-weight: 600
      font-size: 20px
      line-height: 30px
      color: #22223C
      @media screen and (min-width: 0px) and (max-width: 1024px)
        position: absolute
        bottom: -27px
        width: calc(100% - 30px)
        left: 15px
</style>
